import { render } from "./PhoneEdit.vue?vue&type=template&id=52bff5b1"
import script from "./PhoneEdit.vue?vue&type=script&lang=js"
export * from "./PhoneEdit.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./PhoneEdit.vue?vue&type=style&index=0&id=52bff5b1&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__